/*
 * @Author: Johnny.Liu
 * @Date: 2022-04-15 15:11:04
 * @LastEditors: Johnny.Liu
 * @LastEditTime: 2022-04-15 16:21:21
 */
import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/home/index'
import companyThought from '@/components/companyThought'
import aboutUs from '@/components/aboutUs'
import contactUs from '@/components/contactUs'
import InvestmentEducation from '@/components/investment-edu/InvestmentEducation'
import InvestmentEducationNew from '@/components/investment-edu-new/InvestmentEducationNew'
import AdvEdu from '@/components/adv-edu/AdvEdu'
import Eduday from '@/components/Eduday/Eduday'
import EduMon from '@/components/EduMon/EduMon'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      alias: '/home',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/companyThought',
      name: 'companyThought',
      component: companyThought
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },
    {
      path: '/edu',
      name: 'edu',
      component: InvestmentEducation
    },
    {
        path: '/eduNew',
        name: 'eduNew',
        component: InvestmentEducationNew
    },
    {
        path: '/advEdu',
        name: 'advEdu',
        component: AdvEdu
    },
    {
        path: '/eduday',
        name: 'Eduday',
        component: Eduday
    },
    {
        path: '/edumon',
        name: 'edumon',
        component: EduMon
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js